import { SCHOLARSHIP_FORM } from "./utils/constants";

const ScholarshipLink = ({ name, link, label }) => {
  return (
    <a className="ngyv_link" href={link} target="_blank" rel="noreferrer">
      <strong>{name}</strong> - {label}
    </a>
  );
};

const ScholarshipForm = ({ language }) => {
  return (
    <div className="commonTile" id={4}>
      <div className="commonTile_header">
        {SCHOLARSHIP_FORM?.header?.[language]}
      </div>
      <div className="bg-red-900 h-px my-2"></div>
      <div className="notice">{SCHOLARSHIP_FORM?.notice?.[language]}</div>
      <div className="flex flex-col gap-y-2 my-4">
        {SCHOLARSHIP_FORM?.scholarships.map((scholarship, index) => {
          return (
            <ScholarshipLink
              key={`link-${index}`}
              name={scholarship?.name?.[language]}
              link={scholarship?.link}
              label={SCHOLARSHIP_FORM?.link_label?.[language]}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ScholarshipForm;
